function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
var AdvancedDanmakuPanelEditor = function () {
    function AdvancedDanmakuPanelEditor(player, el) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, AdvancedDanmakuPanelEditor);
        this.player = player;
        this.el = el;
        this.template = this.player.template;
        this.view = {};
        this.c = {};
        this.options = options;
        this.keyFrames = [];
        this.currentKeyFrame = 0;
        this.autoCurrentTime = true;
        this.init();
        this.applyDanmaku(this.options.d || {});
    }
    _createClass(AdvancedDanmakuPanelEditor, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                var $ = this.el.querySelector.bind(this.el);
                this.view.ade_panel_preview = $('.mfunsPlayer-ade-preview');
                this.view.ade_panel_emit = $('.mfunsPlayer-ade-emit');
                this.view.ade_panel_copy = $('.mfunsPlayer-ade-copy');
                this.view.ade_panel_copysuccess = $('.mfunsPlayer-ade-copysuccess');
                this.view.ade_panel_preview.onclick = function () {
                    _this.preview();
                };
                this.view.ade_panel_emit.onclick = function () {
                    _this.send();
                };
                this.view.ade_panel_copy.onclick = function () {
                    navigator.clipboard.writeText(_this.generateDanmaku() || '').then(function (res) {
                        _this.view.ade_panel_copysuccess.style.display = '';
                        var timer = setTimeout(function () {
                            _this.view.ade_panel_copysuccess.style.display = 'none';
                            clearTimeout(timer);
                        }, 3000);
                    });
                };
                this.c.area_content = $('.mfunsADEditor-area-content');
                this.c.area_attribute = $('.mfunsADEditor-area-attribute');
                this.c.input_content = $('.mfunsADEditor-input-content');
                this.c.input_color = $('.mfunsADEditor-input-color');
                this.c.input_size = $('.mfunsADEditor-input-size');
                this.c.input_font = $('.mfunsADEditor-input-font');
                this.c.input_bold = $('.mfunsADEditor-input-bold');
                this.c.input_shadow_color = $('.mfunsADEditor-input-shadow-color');
                this.c.input_shadow_x = $('.mfunsADEditor-input-shadow-x');
                this.c.input_shadow_y = $('.mfunsADEditor-input-shadow-y');
                this.c.input_shadow_blur = $('.mfunsADEditor-input-shadow-blur');
                this.c.input_stroke_color = $('.mfunsADEditor-input-stroke-color');
                this.c.input_stroke_width = $('.mfunsADEditor-input-stroke-width');
                this.c.input_start = $('.mfunsADEditor-input-start');
                this.c.input_zIndex = $('.mfunsADEditor-input-zIndex');
                this.c.input_anchor_x = $('.mfunsADEditor-input-anchor-x');
                this.c.input_anchor_y = $('.mfunsADEditor-input-anchor-x');
                this.c.input_duration = $('.mfunsADEditor-input-duration');
                this.c.switch_shadow = $('.mfunsADEditor-switch-shadow');
                this.c.switch_stroke = $('.mfunsADEditor-switch-stroke');
                this.c.switch_current = $('.mfunsADEditor-switch-current');
                this.c.input_a_duration = $('.mfunsADEditor-input-a-duration');
                this.c.input_x = $('.mfunsADEditor-input-x');
                this.c.input_y = $('.mfunsADEditor-input-y');
                this.c.input_rx = $('.mfunsADEditor-input-rx');
                this.c.input_ry = $('.mfunsADEditor-input-ry');
                this.c.input_rz = $('.mfunsADEditor-input-rz');
                this.c.input_scale_x = $('.mfunsADEditor-input-scale-x');
                this.c.input_scale_y = $('.mfunsADEditor-input-scale-y');
                this.c.input_opacity = $('.mfunsADEditor-input-opacity');
                this.c.input_ease = $('.mfunsADEditor-input-ease');
                this.c.switch_position = $('.mfunsADEditor-switch-position');
                this.c.switch_rotation = $('.mfunsADEditor-switch-rotation');
                this.c.switch_scale = $('.mfunsADEditor-switch-scale');
                this.c.switch_opacity = $('.mfunsADEditor-switch-opacity');
                this.c.action_getCurrentTime = $('.mfunsADEditor-action-getCurrentTime');
                this.c.action_delKeyFrame = $('.mfunsADEditor-action-delKeyFrame');
                this.c.action_addKeyFrame = $('.mfunsADEditor-action-addKeyFrame');
                this.c.list_keyFrames = $('.mfunsADEditor-keyframes');
                this.c.area_animation_settings = $('.mfunsADEditor-animation-settings');
                this.c.action_getCurrentTime.onclick = function () {
                    _this.getCurrentTime();
                };
                this.c.action_delKeyFrame.onclick = function () {
                    _this.delKeyFrame();
                };
                this.c.action_addKeyFrame.onclick = function () {
                    _this.addKeyFrame();
                };
                this.c.switch_shadow.onchange = function (e) {
                    _this.c.area_content.classList.toggle('ad-use-shadow', e.currentTarget.checked);
                };
                this.c.switch_stroke.onchange = function (e) {
                    _this.c.area_content.classList.toggle('ad-use-stroke', e.currentTarget.checked);
                };
                this.c.switch_position.onchange = function (e) {
                    _this.c.area_animation_settings.classList.toggle('ad-use-position', e.currentTarget.checked);
                };
                this.c.switch_rotation.onchange = function (e) {
                    _this.c.area_animation_settings.classList.toggle('ad-use-rotation', e.currentTarget.checked);
                };
                this.c.switch_scale.onchange = function (e) {
                    _this.c.area_animation_settings.classList.toggle('ad-use-scale', e.currentTarget.checked);
                };
                this.c.switch_opacity.onchange = function (e) {
                    _this.c.area_animation_settings.classList.toggle('ad-use-opacity', e.currentTarget.checked);
                };
            }
        },
        {
            key: 'addKeyFrame',
            value: function addKeyFrame() {
                this.saveKeyFrame();
                var n = this.currentKeyFrame;
                var newKeyFrame = Object.assign({ duration: 1000 }, this.keyFrames[n]);
                console.log(n);
                this.keyFrames.splice(n + 1, 0, newKeyFrame);
                this._keyframeBarAdd();
                this.switchKeyFrame(n + 1);
            }
        },
        {
            key: 'delKeyFrame',
            value: function delKeyFrame() {
                var n = this.currentKeyFrame;
                if (this.keyFrames.length < 2) {
                    console.log('不能删除初始状态');
                } else {
                    console.log(n);
                    this.keyFrames.splice(n, 1);
                    this._keyframeBarMinus();
                    if (n == 0) {
                        this.switchKeyFrame(0, 'unsave');
                    } else {
                        this.switchKeyFrame(n - 1, 'unsave');
                    }
                }
            }
        },
        {
            key: 'switchKeyFrame',
            value: function switchKeyFrame(n, unsave) {
                if (n != this.currentKeyFrame || unsave) {
                    unsave || this.saveKeyFrame();
                    this.currentKeyFrame = n;
                    var label_on = this.c.list_keyFrames.querySelector('.item-on');
                    label_on && label_on.classList.remove('item-on');
                    this.c.list_keyFrames.querySelector('span:nth-child('.concat(n + 1, ')')).classList.add('item-on');
                    this.c.area_animation_settings.setAttribute('data-frame', n);
                    this.applyKeyFrame();
                } else {
                    this.saveKeyFrame();
                    console.log(this.keyFrames[n]);
                }
            }
        },
        {
            key: 'getCurrentTime',
            value: function getCurrentTime() {
                this.c.input_start.value = parseInt(this.player.video.currentTime * 1000);
            }
        },
        {
            key: 'useAutoCurrentTime',
            value: function useAutoCurrentTime(b) {
                this.autoCurrentTime = b;
            }
        },
        {
            key: 'getDanmakuData',
            value: function getDanmakuData() {
                var _this$keyFrames$0$pos, _this$keyFrames$0$pos2, _this$keyFrames$0$rot, _this$keyFrames$0$rot2, _this$keyFrames$0$rot3, _this$keyFrames$0$sca, _this$keyFrames$0$sca2, _this2 = this;
                this.saveKeyFrame();
                var d = {
                    content: this.c.input_content.value,
                    color: this.c.input_color.value,
                    size: Number(this.c.input_size.value),
                    font: this.c.input_font.value,
                    bold: this.c.input_bold.checked,
                    layer: Number(this.c.input_zIndex.value),
                    anchor: [
                        Number(this.c.input_anchor_x.value),
                        Number(this.c.input_anchor_y.value)
                    ],
                    duration: Number(this.c.input_duration.value),
                    x: (_this$keyFrames$0$pos = this.keyFrames[0].position) === null || _this$keyFrames$0$pos === void 0 ? void 0 : _this$keyFrames$0$pos[0],
                    y: (_this$keyFrames$0$pos2 = this.keyFrames[0].position) === null || _this$keyFrames$0$pos2 === void 0 ? void 0 : _this$keyFrames$0$pos2[1],
                    rotateX: (_this$keyFrames$0$rot = this.keyFrames[0].rotation) === null || _this$keyFrames$0$rot === void 0 ? void 0 : _this$keyFrames$0$rot[0],
                    rotateY: (_this$keyFrames$0$rot2 = this.keyFrames[0].rotation) === null || _this$keyFrames$0$rot2 === void 0 ? void 0 : _this$keyFrames$0$rot2[1],
                    rotateZ: (_this$keyFrames$0$rot3 = this.keyFrames[0].rotation) === null || _this$keyFrames$0$rot3 === void 0 ? void 0 : _this$keyFrames$0$rot3[2],
                    scaleX: (_this$keyFrames$0$sca = this.keyFrames[0].scale) === null || _this$keyFrames$0$sca === void 0 ? void 0 : _this$keyFrames$0$sca[0],
                    scaleY: (_this$keyFrames$0$sca2 = this.keyFrames[0].scale) === null || _this$keyFrames$0$sca2 === void 0 ? void 0 : _this$keyFrames$0$sca2[1],
                    opacity: this.keyFrames[0].opacity,
                    animations: this.keyFrames.slice(1).map(function (k) {
                        return _this2.genADTransform(k);
                    })
                };
                if (!d.animations.length) {
                    d.animations = undefined;
                }
                console.log(d);
                return d;
            }
        },
        {
            key: 'genADTransform',
            value: function genADTransform(f) {
                var _f$position, _f$position2, _f$rotation, _f$rotation2, _f$rotation3, _f$scale, _f$scale2;
                return {
                    duration: f.duration,
                    x: (_f$position = f.position) === null || _f$position === void 0 ? void 0 : _f$position[0],
                    y: (_f$position2 = f.position) === null || _f$position2 === void 0 ? void 0 : _f$position2[1],
                    rotateX: (_f$rotation = f.rotation) === null || _f$rotation === void 0 ? void 0 : _f$rotation[0],
                    rotateY: (_f$rotation2 = f.rotation) === null || _f$rotation2 === void 0 ? void 0 : _f$rotation2[1],
                    rotateZ: (_f$rotation3 = f.rotation) === null || _f$rotation3 === void 0 ? void 0 : _f$rotation3[2],
                    scaleX: (_f$scale = f.scale) === null || _f$scale === void 0 ? void 0 : _f$scale[0],
                    scaleY: (_f$scale2 = f.scale) === null || _f$scale2 === void 0 ? void 0 : _f$scale2[1],
                    opacity: f.opacity
                };
            }
        },
        {
            key: 'generateDanmaku',
            value: function generateDanmaku() {
                var d = this.getDanmakuData();
                return JSON.stringify(d);
            }
        },
        {
            key: 'saveKeyFrame',
            value: function saveKeyFrame() {
                var k = this.keyFrames[this.currentKeyFrame];
                if (this.currentKeyFrame) {
                    k.duration = Number(this.c.input_a_duration.value);
                    k.ease = Number(this.c.input_ease.value);
                }
                k.position = this.c.switch_position.checked ? [
                    Number(this.c.input_x.value),
                    Number(this.c.input_y.value)
                ] : undefined;
                k.rotation = this.c.switch_rotation.checked ? [
                    Number(this.c.input_rx.value),
                    Number(this.c.input_ry.value),
                    Number(this.c.input_rz.value)
                ] : undefined;
                k.scale = this.c.switch_scale.checked ? [
                    Number(this.c.input_scale_x.value),
                    Number(this.c.input_scale_y.value)
                ] : undefined;
                k.opacity = this.c.switch_opacity.checked ? Number(this.c.input_opacity.value) : undefined;
            }
        },
        {
            key: 'applyKeyFrame',
            value: function applyKeyFrame() {
                var k = this.keyFrames[this.currentKeyFrame];
                this.c.input_a_duration.value = k.duration || 0;
                this.c.input_x.value = k.position ? k.position[0] : 0;
                this.c.input_y.value = k.position ? k.position[1] : 0;
                this.c.input_rx.value = k.rotation ? k.rotation[0] : 0;
                this.c.input_ry.value = k.rotation ? k.rotation[1] : 0;
                this.c.input_rz.value = k.rotation ? k.rotation[2] : 0;
                this.c.input_scale_x.value = k.scale ? k.scale[0] : 1;
                this.c.input_scale_y.value = k.scale ? k.scale[1] : 1;
                this.c.input_opacity.value = k.opacity != undefined ? k.opacity : 1;
                this.c.switch_position.checked = Boolean(k.position);
                this.c.switch_rotation.checked = Boolean(k.rotation);
                this.c.switch_scale.checked = Boolean(k.scale);
                this.c.switch_opacity.checked = k.opacity != undefined;
                this.c.area_animation_settings.classList.toggle('ad-use-position', Boolean(k.position));
                this.c.area_animation_settings.classList.toggle('ad-use-rotation', Boolean(k.rotation));
                this.c.area_animation_settings.classList.toggle('ad-use-scale', Boolean(k.scale));
                this.c.area_animation_settings.classList.toggle('ad-use-opacity', k.opacity != undefined);
            }
        },
        {
            key: 'applyDanmaku',
            value: function applyDanmaku(d) {
                this.c.input_content.value = d.content || '';
                this.c.input_color.value = d.color || '#ffffff';
                this.c.input_size.value = d.size || '36';
                this.c.input_font.value = d.font || 'SimHei';
                this.c.input_bold.checked = d.bold || false;
                this.c.switch_shadow.checked = Boolean(d.shadow);
                this.c.area_content.classList.toggle('ad-use-shadow', Boolean(d.shadow));
                if (d.shadow) {
                    this.c.input_shadow_color.value = d.shadow[0] || '#000000';
                    this.c.input_shadow_x.value = d.shadow[1] || 0;
                    this.c.input_shadow_y.value = d.shadow[2] || 0;
                    this.c.input_shadow_blur.value = d.shadow[3] || 0;
                }
                this.c.switch_stroke.checked = Boolean(d.stroke);
                this.c.area_content.classList.toggle('ad-use-stroke', Boolean(d.stroke));
                if (d.stroke) {
                    this.c.input_stroke_color.value = d.stroke[0] || '#000000';
                    this.c.input_stroke_width.value = d.stroke[1] || 0;
                }
                this.c.input_start.value = d.start || 0;
                this.c.input_zIndex.value = d.zIndex || 50;
                this.c.input_duration.value = d.duration || 1000;
                this.c.switch_current.checked = d.start == undefined;
                this.keyFrames = [{
                        position: d.position || [
                            0,
                            0
                        ],
                        rotation: d.rotation,
                        scale: d.scale,
                        opacity: d.opacity
                    }].concat(d.animations || []);
                this.applyKeyFrame();
                this.initKeyframeBar();
            }
        },
        {
            key: 'initKeyframeBar',
            value: function initKeyframeBar() {
                var _this3 = this;
                var list = document.createDocumentFragment();
                var _loop = function _loop(i) {
                    var btn = document.createElement('span');
                    btn.innerText = i;
                    btn.setAttribute('data-value', i);
                    btn.onclick = function () {
                        _this3.switchKeyFrame(i);
                    };
                    if (i == _this3.currentKeyFrame) {
                        btn.classList.add('item-on');
                    }
                    list.appendChild(btn);
                };
                for (var i = 0; i < this.keyFrames.length; i++) {
                    _loop(i);
                }
                this.c.list_keyFrames.appendChild(list);
            }
        },
        {
            key: '_keyframeBarAdd',
            value: function _keyframeBarAdd() {
                var _this4 = this;
                var n = this.c.list_keyFrames.childElementCount;
                var btn = document.createElement('span');
                btn.innerText = n;
                btn.setAttribute('data-value', n);
                btn.onclick = function () {
                    _this4.switchKeyFrame(n);
                };
                this.c.list_keyFrames.appendChild(btn);
            }
        },
        {
            key: '_keyframeBarMinus',
            value: function _keyframeBarMinus() {
                this.c.list_keyFrames.removeChild(this.c.list_keyFrames.lastElementChild);
            }
        },
        {
            key: 'preview',
            value: function preview() {
                var _this5 = this;
                var danmaku = {
                    content: this.generateDanmaku(),
                    time: this.c.switch_current.checked ? this.player.video.currentTime * 1000 : Number(this.c.input_start.value),
                    id: 'preview-'.concat(Date.now())
                };
                if (!this.c.switch_current.checked) {
                    this.player.seek(danmaku.time / 1000);
                }
                window.requestAnimationFrame(function () {
                    _this5.player.advancedDanmaku.engine.playDanmaku(danmaku);
                });
            }
        },
        {
            key: 'send',
            value: function send() {
                var danmaku = {
                    content: this.generateDanmaku(),
                    time: this.c.switch_current.checked ? this.player.video.currentTime * 1000 : Number(this.c.input_start.value)
                };
                console.log(JSON.parse(this.generateDanmaku()));
                console.log(danmaku);
                this.player.advancedDanmaku.engine.addDanmaku(danmaku);
                if (this.c.switch_current.checked) {
                    this.player.advancedDanmaku.engine.playDanmaku(danmaku);
                }
            }
        }
    ]);
    return AdvancedDanmakuPanelEditor;
}();
export default AdvancedDanmakuPanelEditor;